export default __webpack_public_path__ + "static/media/4.67cb0fbe.jpg";